// extracted by mini-css-extract-plugin
export default {"nextPreviewPage":"nextPreviewPage-qIqOQ","bottom":"bottom-I3Dsl","desc":"desc-Ww8gQ","text":"text-FISJ4","progress":"progress-g0n3Y"};